module.exports = __webpack_public_path__ + "assets/icon-upload-component.a2cbb582.svg";